"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConstructionProgress = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./ConstructionProgress.css"));
var _Link = require("../../../Link");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ConstructionProgress = props => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    fontWeight: "bold"
  }, "\u0424\u043E\u0442\u043E \u0441\u0442\u0440\u043E\u0439\u043A\u0438"), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "gray40_100"
  }, props.status), /*#__PURE__*/React.createElement("div", {
    className: styles['photos']
  }, props.photo.map((photo, index) => /*#__PURE__*/React.createElement("img", {
    className: styles['photo'],
    key: index,
    src: photo,
    alt: `photo-${index}`
  }))), props.url && /*#__PURE__*/React.createElement(_Link.Link, {
    theme: "primary",
    url: props.url,
    target: "blank"
  }, "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E"));
};
exports.ConstructionProgress = ConstructionProgress;